import { DockSignEngineComponent } from '@documalis/docksignengine/docksignengine.component';

// Déclaration des routes des docks
export const docksScreenRoutes = [
    { path: '', component: DockSignEngineComponent, outlet: 'signengine' },
];